import { TOOLS } from "const";
import { SettingsActionTypes } from "./types";

// common success
export const settingsApiResponseSuccess = (actionType: string, data: any) => ({
  type: SettingsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const settingsApiResponseError = (
  actionType: string,
  error: string
) => ({
  type: SettingsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getSettings = () => ({
  type: SettingsActionTypes.GET_USER_SETTINGS,
});

export const loadThirdApiUrl = () => ({
  type: SettingsActionTypes.LOAD_THIRD_API_URL,
});

export const updateSettings = (field: string, value: any) => ({
  type: SettingsActionTypes.UPDATE_USER_SETTINGS,
  payload: { field, value },
});

export const ucSetConfigValue = (configKey: string, configValue: any) => ({
  type: SettingsActionTypes.UC_SET_CONFIG_VALUE,
  payload: { configKey, configValue },
});


export const ucLoadUserConfig = () => ({
  type: SettingsActionTypes.UC_LOAD_USER_CONFIG,
  payload: {}
})

export const setActiveTool = (tool: TOOLS | null) => ({
  type: SettingsActionTypes.SET_ACTIVE_TOOL,
  paylload: { tool }
})

export const setOrgDdlValueForPerm = (data: any) => ({
  type: SettingsActionTypes.SET_ORG_DDL_VALUE_FOR_PERM,
  payload: { data }
});